/// jacques-andre-editeur\JAEfrontend\src\screens\admin\OrderListScreen.jsx
import { Table, Container, Button } from 'react-bootstrap';
import { FaCheck, FaTimes } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import Message from '../../components/Message';
import Loader from '../../components/Loader';
import { useGetOrdersQuery, useDeliverOrderMutation, useDeleteOrderMutation } from '../../slices/ordersApiSlice';

const OrderListScreen = () => {
  const { data: orders, isLoading, error, refetch } = useGetOrdersQuery();
  const [deliverOrder, { isLoading: loadingDeliver }] = useDeliverOrderMutation();
  const [deleteOrder] = useDeleteOrderMutation();
  const navigate = useNavigate();

  const markAsSentHandler = async (orderId) => {
    if (window.confirm('Confirmer l’envoi de cette commande ?')) {
      try {
        await deliverOrder(orderId).unwrap();
        refetch(); // recharge la liste après la mise à jour
      } catch (err) {
        console.error(err);
        alert('Erreur lors de la mise à jour');
      }
    }
  };

  const deleteOrderHandler = async (orderId) => {
    if (window.confirm('Supprimer toute trace sur le site de cette commande ? Cette action est définitive.')) {
      try {
        await deleteOrder(orderId).unwrap();
        refetch(); // recharge la liste
      } catch (err) {
        console.error(err);
        alert(err?.data?.message || 'Erreur lors de la suppression');
      }
    }
  };

  return (
    <Container>
      <h1>Commandes</h1>
      {isLoading || loadingDeliver ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">
          {error?.data?.message || error.error}
        </Message>
      ) : (
        <Table striped bordered hover responsive className="table-sm">
  <thead>
    <tr>
      <th>N° commande</th>
      <th>Client</th>
      <th>Pays</th>
      <th>Nb livres</th>
      <th>Prix total</th>
      <th>Payé</th> {/* nouvelle colonne */}
      <th>Envoyée</th>
      <th>Date d’envoi</th>
      <th>Suppression définitive</th>
    </tr>
  </thead>
  <tbody>
    {orders?.map((order) => (
      <tr
        key={order._id}
        style={{ cursor: 'pointer' }}
        onClick={() => navigate(`/admin/order/${order._id}`)}
      >
        <td>{order.orderNumber || '—'}</td>
        <td>
          {order.billingAddress?.prenom} {order.billingAddress?.nom}
        </td>
        <td>{order.billingAddress?.pays}</td>
        <td>
          {order.orderItems?.reduce((acc, item) => acc + item.qty, 0)}
        </td>
        <td>{order.totalPrice.toFixed(2)} €</td>
        <td className="text-center">
          {order.isPaid ? (
            <FaCheck style={{ color: 'green' }} title="Payé" />
          ) : (
            <FaTimes style={{ color: 'red' }} title="Non payé" />
          )}
        </td>
        <td
          className="text-center"
          onClick={(e) => e.stopPropagation()} // évite d’ouvrir la page détail si on clique sur le bouton
        >
          {order.isSent ? (
            <FaCheck style={{ color: 'green' }} />
          ) : (
            <Button
              variant="light"
              size="sm"
              onClick={() => markAsSentHandler(order._id)}
            >
              <FaTimes
                title="Marquer comme envoyé"
                style={{ color: 'red', cursor: 'pointer' }}
              />
            </Button>
          )}
        </td>
        <td>
          {order.isSent && order.sentAt
            ? new Date(order.sentAt).toLocaleDateString('fr-FR')
            : '-'}
        </td>
        <td
          className="text-center"
          onClick={(e) => e.stopPropagation()} // évite d’ouvrir la commande
        >
          {order.isSent ? (
            <Button
              variant="danger"
              size="sm"
              onClick={() => deleteOrderHandler(order._id)}
            >
              X
            </Button>
          ) : (
            <span style={{ color: '#999' }}>—</span> // non supprimable
          )}
        </td>

      </tr>
    ))}
  </tbody>
</Table>

      )}
    </Container>
  );
};

export default OrderListScreen;
